<template>
  <div class="order-system">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">高效工单处理体系，打通服务全流程链路</div>
      </div>
      <div class="module-body">
        <div class="tabs-header">
          <div class="tab-item" :class="{ active: tab.id === activeId }" v-for="tab in dataList" :key="tab.id" @click="activeId=tab.id">{{ tab.name }}</div>
        </div>
        <div class="tabs-body">
          <transition name="tab">
            <template v-for="tab in dataList">
              <div class="tab-panel" :key="tab.id" v-if="tab.id === activeId" :style="{ backgroundImage: `url(${tab.background})` }">
                <div class="name">{{ tab.name }}</div>
                <div class="introduce">{{ tab.introduce }}</div>
                <div class="slogans">
                  <div class="slogan-item" v-for="(item, index) in tab.slogans" :key="index">{{ item }}</div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: [
        {
          id: 'fwtdksgj',
          name: '服务团队快速构建',
          introduce: '通过人员信息、技能标签、权限配置等数字化体系，快速聚合适配工单的专业服务团队，夯实服务执行“基石”。',
          slogans: ['人员信息智能维护', '技能标签精准打标', '服务权限灵活配置', '团队一键聚合调度'],
          background: require('@/assets/img/service-provider/OrderSystem/item_background_fwtdksgj.png')
        },
        {
          id: 'yddmjzy',
          name: '移动端敏捷作业',
          introduce: '工程师通过 APP 实时承接工单，支持接单、异地打卡、进度更新、实施交付，实现全流程移动化，打破时空壁垒提效协作。',
          slogans: ['工单实时推送提醒', '异地打卡便捷化', '节点进度反馈', '实施交付全跟踪'],
          background: require('@/assets/img/service-provider/OrderSystem/item_background_yddmjzy.png')
        },
        {
          id: 'gdsjzngk',
          name: '工单数据智能管控',
          introduce: '可视化看板可呈现工单全生命周期数据，支持多维度筛选、分析与导出，为运营决策提供数据支撑。',
          slogans: ['数据看板可视化呈现', '多维度数据筛选分析', '数据一键导出留存功能 '],
          background: require('@/assets/img/service-provider/OrderSystem/item_background_gdsjzngk.png')
        },
        {
          id: 'qlcgzygt',
          name: '全流程跟踪与沟通',
          introduce: '用户可实时追踪工单进度，系统自动推送节点通知，还支持双向沟通，以此提升服务透明度与满意度。',
          slogans: ['全流程进度实时追踪', '节点状态自动通知', '服务方双向沟通 '],
          background: require('@/assets/img/service-provider/OrderSystem/item_background_qlcgzygt.png')
        }
      ],
      activeId: ''
    }
  },
  created() {
    this.activeId = this.dataList[0].id;
  }
};
</script>

<style lang="less" scoped>
.order-system {
  padding: 64px 0;
  background-image: url('@/assets/img/service-provider/OrderSystem/background.png');
  background-size: cover;
  background-position: center;
  background-color: #fff;

  .content-center {
    .module-body {
      height: 397px;
      margin-top: 40px;
      background: rgba(255, 255, 255, 0.78);
      border-radius: 14px;
      display: flex;
      align-items: center;

      .tabs-header {
        width: 220px;
        height: 300px;
        padding: 15px 0;
        border-right: 1px solid #D9D9D9;
        .tab-item {
          padding-left: 43px;
          line-height: 48px;
          cursor: pointer;
          & + .tab-item {
            margin-top: 8px;
          }
          &:hover {
            background-color: #FFEDDA;
          }
          &.active {
            background-color: #FFEDDA;
            position: relative;
            &::before {
              content: '';
              width: 3px;
              height: 100%;
              background-color: #FF8201;
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }
      }

      .tabs-body {
        flex: 1;
        height: 100%;
        position: relative;
        .tab-panel {
          width: calc(100% - 81px);
          height: calc(100% - 85px);
          background-repeat: no-repeat;
          background-position: right bottom;
          position: absolute;
          left: 48px;
          top: 64px;
          transition: all 0.4s ease;
          .name {
            font-weight: bold;
            font-size: 20px;
          }
          .introduce {
            margin-top: 20px;
            font-size: 14px;
          }
          .slogans {
            margin-top: 39px;
            .slogan-item {
              padding-left: 28px;
              font-size: 14px;
              position: relative;
              & + .slogan-item {
                margin-top: 20px;
              }
              &::before {
                content: '';
                width: 16px;
                height: 16px;
                background-image: url('@/assets/img/service-provider/OrderSystem/icon_check.png');
                background-size: 100% 100%;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
        .tab-enter {
          transform: translateY(20px);
          opacity: 0;
        }
        .tab-leave-to {
          transform: translateY(-20px);
          opacity: 0;
        }
      }
    }
  }
}
</style>
